const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/subscriptions/$subscriptionId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/subscriptions/$subscriptionId")({
  beforeLoad: args => requirePermission(Permissions.Subscriptions.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type DialogKey = "extend" | "reenable" | "changeTier" | "changeBillingAccount" | "cancel" | "pause" | "resume" | "addBlock" | "convertTrial" | null;